module.exports = __webpack_public_path__ + "img/gear-transparent.4a929df8.png";